<template>
  <v-row>
    <v-col class="pa-0">
      <CalendarWeekDay
        @calendarClick="$emit('clicked', $event)"
        :date="today.toISOString().substr(0, 10)"
        :subject-classes="todaysClasses"
      />
    </v-col>
    <v-col class="pa-0">
      <CalendarWeekDay
        @calendarClick="$emit('clicked', $event)"
        :date="tomorrow.toISOString().substr(0, 10)"
        :subject-classes="tomorrowClasses"
      />
    </v-col>
    <v-col class="pa-0">
      <CalendarWeekDay
        @calendarClick="$emit('clicked', $event)"
        :subject-classes="afterTomorrowClasses"
        :date="afterTomorrow.toISOString().substr(0, 10)"
      />
    </v-col>
  </v-row>
</template>

<script>
import CalendarWeekDay from "./calendar/CalendarWeekDay";

const weekdays = {
  0: "sunday",
  1: "monday",
  2: "tuesday",
  3: "wednesday",
  4: "thursday",
  5: "friday",
  6: "satuday"
};

export default {
  components: {
    CalendarWeekDay
  },
  props: {
    subjectClasses: Array
  },
  computed: {
    tomorrow() {
      return this.addDays(this.today, 1);
    },
    afterTomorrow() {
      return this.addDays(this.today, 2);
    },
    todaysClasses() {
      return this.filterClasses(weekdays[this.today.getDay()]);
    },
    tomorrowClasses() {
      return this.filterClasses(weekdays[this.tomorrow.getDay()]);
    },
    afterTomorrowClasses() {
      return this.filterClasses(weekdays[this.afterTomorrow.getDay()]);
    }
  },
  data() {
    return {
      today: new Date()
    };
  },
  methods: {
    addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);

      return result;
    },
    filterClasses(weekday) {
      return this.subjectClasses.filter(
        subjectClass => subjectClass.day_of_week === weekday
      );
    }
  }
};
</script>
